import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './ArticleNav.module.scss';
import qs from 'query-string';

const ArticleNav = (props) => {

  const location = useLocation();
  const navigate = useNavigate();

  const params = qs.parse(location.search);

  const listCategories = (categories) => {
    let arr = [];
    const currentBoardId = parseInt(params.boardId);
    
    categories.forEach((x, index) => {
      arr.push(
        <div key = {index} className={styles.nav_item}>
          <div key={index} className={styles.parent}
            onClick={() => {
              params.boardId = x.id;
              params.command = 'list';
              delete params.page;
              delete params.limit;
              delete params.fromRoot;
              const url = location.pathname + '?' + qs.stringify(params);
              navigate(url);
            }}
          ><p className={x.id === currentBoardId ? styles.selected : styles.normal}>{x.title}</p></div>
          {x.childCount > 0 && x.children.map((y, index) => {
            return <div key={index + x.id} className={styles.child}
            onClick={() => {
              params.boardId = y.id;
              params.command = 'list';
              delete params.page;
              delete params.limit;
              delete params.fromRoot;
              const url = location.pathname + '?' + qs.stringify(params);
              navigate(url);
            }}
          ><p className={y.id === currentBoardId ? styles.selected : styles.normal}>ㄴ {y.title}</p></div>
          })
          }
        </div>)
    });

    return arr;
  }

  return (
    <div id={styles.wrapper_articleNav}>
      <div id={styles.nav}>
        <div id={styles.header} onClick={() => {
          delete params.boardId;
          params.command = 'list';
          params.fromRoot = 'true';
          const url = location.pathname + '?' + qs.stringify(params);
          navigate(url);
        }}>
          <p>커뮤니티</p>
        </div>
        <div id={styles.list}>
          {listCategories(props.categories)}
        </div>
      </div>
    </div>
  )
}

export default ArticleNav